
<div class="field" *ngIf="field" [class.empty]="!field.content &amp;&amp; !field.rasterized"><span class="label">{{ field.label }} : &nbsp;</span><span>{{ field.content }}</span>
  <ng-template #content>
    <div class="content" [innerHTML]="field.content" [class.hasEllipsis]="hasEllipsis" [class.isExpanded]="isExpanded || (ms &amp;&amp; ms.isLoading)" (click)="isExpanded=!isExpanded"></div>
  </ng-template>
</div>
